export default "__VITE_ASSET__BetiNG7n__"